import { render, staticRenderFns } from "./TeamOverview.vue?vue&type=template&id=e46b235e&scoped=true&lang=pug&"
import script from "./TeamOverview.vue?vue&type=script&lang=js&"
export * from "./TeamOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46b235e",
  null
  
)

export default component.exports